import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';
import Notification from '@/components/Notification';
import { useLogOut } from '@/hooks/useLogOut';
import { ROUTES } from '@/router';

type Props = {
  instanceId: string;
};

const LoginAsNotification = ({ instanceId }: Props) => {
  const { clearCacheOnly } = useLogOut();

  const handleReturnToHomeOrg = () => {
    clearCacheOnly();
    // reload the page to clear all state
    window.location.href = ROUTES.app.path;
  };

  return (
    <Notification className="flex items-center" type="info" size="large">
      <div className="flex items-center justify-between">
        <Trans>REMINDER! You are currently an Admin in instance: "{instanceId}"</Trans>
        <Button size="small" inverse onClick={handleReturnToHomeOrg}>
          <Trans>Return To Your Org</Trans>
        </Button>
      </div>
    </Notification>
  );
};

export default LoginAsNotification;
